var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-detail"},[_c('div',{staticClass:"page-detail-inner"},[_c('FichaEstructura',{attrs:{"id":_vm.id,"entidad":_vm.entidad,"asideDrawer":false,"asideStatic":true,"detailPage":true},on:{"openWindow":_vm.nuevaVentana}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }